
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import FormCreate from './users/FormCreate';
import FormLogin from './users/FormLogin';
import SelectUserType from './users/SelectUserType'

const UserIndex = forwardRef((props, ref) => {
    const [currentTab, setCurrentTab] = useState("user_form");

    const toogleTab = (current_tab) => {
        setCurrentTab(current_tab)
    }

    if(currentTab == "general"){
        return (
            <React.Fragment>
                <SelectUserType
                    toogleTab={toogleTab}
                />
            </React.Fragment>
        );
    }

    if(currentTab == "user_form"){
        return (
            <React.Fragment>
                <FormCreate
                    setUserState={props.setUserState}
                    toogleTab={toogleTab}
                    tooglePasstab={props.toogleTab}
                    professions={props.professions}
                    cities={props.cities}
                    document_types={props.document_types}
                    countries={props.countries}
                    price={props.price}
                    discount={props.discount}
                    current_country={props.current_country}
                    affiliate={props.affiliate}
                    label_document={props.label_document}
                    reference={props.reference}
                />
            </React.Fragment>
        );
    }

    if(currentTab == "user_login"){
        return (
            <React.Fragment>
                <FormLogin
                    tooglePasstab={props.toogleTab}
                    setUserState={props.setUserState}
                    toogleTab={toogleTab}
                    price={props.price}
                    discount={props.discount}
                    reference={props.reference}
                />
            </React.Fragment>
        );
    }
});


export default UserIndex;
